import { takeLatest, put, call } from 'redux-saga/effects';

import { findVendaProducaoAgricola } from '../service';
import {
  FIND_VENDA_PRODUCAO_AGRICOLA,
  FIND_VENDA_PRODUCAO_AGRICOLA_PENDING,
  FIND_VENDA_PRODUCAO_AGRICOLA_SUCCESS,
  FIND_VENDA_PRODUCAO_AGRICOLA_FAILURE
} from '../actionTypes';

function* sagaFindVendaProducaoAgricola(action) {
  yield put({ type: FIND_VENDA_PRODUCAO_AGRICOLA_PENDING, id: action.id })

  try {

    const registro = yield call(findVendaProducaoAgricola, action.id);

    yield put({ type: FIND_VENDA_PRODUCAO_AGRICOLA_SUCCESS, registro: registro })

  } catch (error) {

    yield put({ type: FIND_VENDA_PRODUCAO_AGRICOLA_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchFindVendaProducaoAgricola() {
  yield takeLatest(FIND_VENDA_PRODUCAO_AGRICOLA, sagaFindVendaProducaoAgricola)
}
